    export const BRAND_ENUM = {
        VT: "Volvo Trucks",
        VB: "Volvo Buses",
        VE: "Volvo Energy",
        RT: "Renault Trucks"
    } as const;

    export type BrandEnum = (typeof BRAND_ENUM)[keyof typeof BRAND_ENUM];